(ns basic-components.inputs.multi-select
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [basic-components.inputs.select :as single-select]
   [clojure.string :as string]
   [common.entity :as entity]
   [frontend.components.open-search-select :as open-search-select]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [reagent.impl.component :as reagent-component]))

(defn force-remount?
  [prev-props new-props]
  (let [;;remounting if these props change - update list as needed:
        remount-prop-keys [:value :options :field/entity-types :entity/type]
        prev-remount-values (-> prev-props
                                (select-keys remount-prop-keys))
        new-remount-values (-> new-props
                               (select-keys remount-prop-keys))]
    (not= prev-remount-values new-remount-values)))

(defmethod editor :editor.type/multi-select
  [args]
  (let [dom-atom (r/atom nil)
        key-atom (r/atom (str (gensym "select-component")))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        use-ref-selector? (some #{(:field/data-type args)}
                                [:data.type/ref-multi :data.type/ref-single])
        set-save! (:set-save! args)]                                                                ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Multi-select-basic"
      :component-did-mount    (fn [mount-args]
                                (let []
                                  ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                                  ;; events withing this editor if needed
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when (:auto-focus args)
                                    (js/setTimeout (fn [_]
                                                     (when-let [dom-node (:input-dom-node @dom-atom)]
                                                       (.focus dom-node)))
                                                   100))

                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc
                                                               :temp-select-value))))               ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))
                                  (when (and use-ref-selector?
                                             (coll? (:value args))
                                             (->> args
                                                  :value
                                                  (some (fn [v]
                                                          (and (not (:label v))
                                                               (not (:db/id v))
                                                               (number? v)))))))))
      :component-did-update   (fn [this old-argv]
                                (let [prev-props (reagent-component/extract-props old-argv)
                                      new-props (r/props this)]
                                  #_(when (force-remount? prev-props new-props)
                                      (reset! key-atom (str (gensym "select-component"))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (if use-ref-selector?
                                  ;; (contains? #{:oppo-information :oppo-asset} module-id) (= "related-entity__select" (:class-name args))
                                  (open-search-select/render-async-select-multi args)
                                  (single-select/render-select dom-atom
                                                               (assoc args
                                                                      :key-atom key-atom
                                                                      :is-multi true))))})))

(defmethod display-string :editor.type/multi-select
  [args]
  (let [value (:value args)
        selected (if (coll? value) value [value])
        options (:options args)
        labels (if (nil? options)
                 (->> selected
                      (keep session/get-entity)
                      (map (fn [entity]
                             (entity/display-string entity :short session/get-entity))))
                 (->> selected
                      (map (fn [s]
                             (let [js-s (clj->js s)]
                               (->> options
                                    (filter (fn [o]
                                              (or (= (:key o) s)
                                                  (= (:key o) js-s))))
                                    (first)
                                    (:label)))))))]
    (string/join ", " labels)))

(defmethod viewer :editor.type/multi-select
  [args]
  (r/create-class
   {:display-name "multi-select/viewer"
    :reagent-render
    (fn [args]
      (let [selected (:value args)
            component-id (:id args)
            attribute (:attribute args)
            options (:options args)]
        [:div.preview.preview-multi-select
         (->>
          selected
          (map (fn [v]
                 (let [label (or (->> options
                                      (filter (fn [o]
                                                (or (= (:key o) v)
                                                    (= (:keyword o) v))))
                                      (first)
                                      :label)
                                 (when (number? v)
                                   (let [entity (session/get-entity v)]
                                     (entity/display-string entity :short session/get-entity))))
                       clickable? (and (number? v)
                                       (let [entity-type (:entity/type (get @session/entities v))]
                                         (some #{entity-type} routing/clickable-entity-types)))]
                   (if clickable?
                     [:span
                      {:key      (str component-id "-comp-" attribute "-" v)
                       :href     "#"
                       :on-click (fn [e]
                                   (routing/open-entity v)
                                   (.preventDefault e))}
                      label]
                     [:span {:key (str component-id "-comp-" attribute "-" v)}
                      label]))))
          (doall))]))}))
